import { createContext } from "react";

const ShoppingCartContext = createContext();

export default ShoppingCartContext;
